import {
  Box,
  Flex,
  Grid,
  Image,
  Text,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText
} from '@chakra-ui/react';
import React from 'react';
import { IoIosPeople } from 'react-icons/io';

import PageContainer from '../../components/pageContainer/PageContainer';

import adityaImg from './aditya.png';
import alexImg from './alex.png';
import bhojanImg from './bhojan.png';
import durveshImg from './durvesh.png';
import francisImg from './francis.png';
import guanhongImg from './guanhong.png';

function About() {
  const createImg = (img, url) => {
    const programImg = <Image objectFit='contain' h='200px' w='100%' src={img}/>;

    return (
      <a href={url}>
        {programImg}
      </a>
    );
  };

  const createCard = (info, i) => {
    const { name, img, url, roles } = info;
    return (
      <Box key={i} w='100%' h='400px'>
        <Box w='100%' maxH='400px' borderRadius='4px' border='1px' borderColor='blackAlpha.300' overflow='auto'>
          <Stat margin='10px'>
            <StatLabel>
              {createImg(img, url)}
            </StatLabel>
            <StatNumber fontWeight='500' textAlign='left'>{name}</StatNumber>
            {(roles.length > 0) && <StatHelpText textAlign='left'>
              <Flex flexDir='row'>
                <Box><IoIosPeople height='16px' width='16px' size='16px'/></Box>
                <Flex flexDir='column'>
                  {
                    roles.map((role, i) => <Text key={i} position='relative' bottom='1px'>{role}</Text>)
                  }
                </Flex>
              </Flex>
            </StatHelpText>}
          </Stat>
        </Box>
      </Box>
    );
  };

  return (
    <PageContainer>
      <Text color='#377DFF' fontSize='2xl' fontWeight={500}>About Us</Text>
      <Grid gridGap='20px' gridTemplateColumns='repeat(auto-fit, minmax(100px, 30%))' w='70%' justifyContent='center' justifyItems='center' alignItems='center'>
        {
          [
            {
              name: 'Aditya Ranjan',
              img: adityaImg,
              url: 'https://www.linkedin.com/in/adityaranjan8/',
              roles: ['Co-Founder', 'President - Business Management']
            },
            {
              name: 'Durvesh Deshmukh',
              img: durveshImg,
              url: 'https://www.linkedin.com/in/durvesh-deshmukh/',
              roles: ['Co-Founder', 'President - Technical Operations']
            },
            {
              name: 'Dr. Anand Bhojan',
              img: bhojanImg,
              url: 'https://www.linkedin.com/in/bhojan/',
              roles: ['Co-Founder', 'Advisor']
            }
          ].map(createCard)
        }
      </Grid>
      <Text color='#377DFF' fontSize='2xl' fontWeight={500}>Advisory Committee</Text>
      <Grid gridGap='20px' gridTemplateColumns='repeat(auto-fit, minmax(100px, 30%))' w='70%' justifyItems='center' alignItems='center'>
      {
          [
            {
              name: 'Dr. Francis Yeoh',
              img: francisImg,
              url: 'https://www.linkedin.com/in/francis-yeoh-dr-16b168/',
              roles: []
            },
            {
              name: 'Dr. Guan Hong Tan',
              img: guanhongImg,
              url: 'https://www.linkedin.com/in/drtanguanhong/',
              roles: []
            },
            {
              name: 'Dr. Alex Siow',
              img: alexImg,
              url: 'https://www.linkedin.com/in/alex-siow-cmc-af-ccsk-5213b4/',
              roles: []
            }
          ].map(createCard)
        }
      </Grid>
    </PageContainer>
  );
}

export default About;
